export default __webpack_public_path__ + "static/media/forest.f218e74d.svg";